import { LeafletGeoJsonLayerComponent } from './../leaflet-blocks/leaflet-geo-json-layer/leaflet-geo-json-layer.component';
import { TileLayer } from './../../../../../node_modules/@types/leaflet/index.d';
import { LeafletMarkerComponent } from './../leaflet-blocks/leaflet-marker/leaflet-marker.component';
import { LeafletCurveComponent } from './../leaflet-blocks/leaflet-curve/leaflet-curve.component';
import { Coordinates } from './../../../models/coordinates.model';
import { LeafletCircleComponent } from './../leaflet-blocks/leaflet-circle/leaflet-circle.component';
import { LeafletPathComponent } from './../leaflet-blocks/leaflet-path/leaflet-path.component';
import { LeafletLayerComponent } from './../leaflet-blocks/leaflet-layer/leaflet-layer.component';
import { LeafletCircleMarkerComponent } from './../leaflet-blocks/leaflet-circle-marker/leaflet-circle-marker.component';
import { LocationService } from './../../../services/location.service';
import { AfterContentInit, AfterViewInit, Component, ContentChildren, OnInit, QueryList } from '@angular/core';

import * as L from 'leaflet';
import { LeafletTileLayerComponent } from '../leaflet-blocks/leaflet-tile-layer/leaflet-tile-layer.component';
import { LeafletArcComponent } from '../leaflet-blocks/leaflet-arc/leaflet-arc.component';

import '@elfalem/leaflet-curve';
import { LeafletBlockComponent } from '../leaflet-blocks/leaflet-block-component.interface';

@Component({
    selector: 'leaflet-map',
    templateUrl: './leaflet-map.component.html',
    styleUrls: ['./leaflet-map.component.scss'],
    standalone: false
})
export class LeafletMapComponent implements OnInit, AfterViewInit, AfterContentInit {

	@ContentChildren(LeafletTileLayerComponent) public tileLayers!: QueryList<LeafletTileLayerComponent>;

	@ContentChildren(LeafletLayerComponent) public layers!: QueryList<LeafletLayerComponent>;
	@ContentChildren(LeafletGeoJsonLayerComponent) public geoJSONlayers!: QueryList<LeafletGeoJsonLayerComponent>;

	@ContentChildren(LeafletPathComponent) public paths!: QueryList<LeafletPathComponent>;
	@ContentChildren(LeafletMarkerComponent) public markers!: QueryList<LeafletMarkerComponent>;
	@ContentChildren(LeafletCircleMarkerComponent) public circleMarkers!: QueryList<LeafletCircleMarkerComponent>;
	@ContentChildren(LeafletCircleComponent) public circles!: QueryList<LeafletCircleComponent>;
	
	@ContentChildren(LeafletCurveComponent) public curves!: QueryList<LeafletCurveComponent>;
	@ContentChildren(LeafletArcComponent) public arcs!: QueryList<LeafletArcComponent>;

	private _map: L.Map;

	private addComponentsAsLayers(components: QueryList<LeafletBlockComponent>, overlays: any): void {

		components.forEach(
			component => {

				let layerGroup = L.layerGroup();

				component.initialize(layerGroup, this._map);
				component.updateLayerGroup();

				if (component.includeInOverlays) {
					overlays[component.name] = layerGroup;

					if (component.isDefault) {
						this._map.addLayer(layerGroup); // Markers enabled by default in overlays.
					}
				} else {
					this._map.addLayer(layerGroup);
				}
			}
		);
	}

	// public getJSON(): Observable<any> {
  //   return this._base.get("./assets/mydata.json")
  //     .map((res:any) => res.json())
  //     .catch((error:any) => console.log(error));

  // }

	public async initializeMap(): Promise<void> {
		let currentPosition: Coordinates = await this._locationService.getCurrentPosition();

		let baseLayers = {};

		let defaultTileLayer: TileLayer;

		this.tileLayers.forEach(
			tileLayerComponent => {
				
				let tileLayer = L.tileLayer(
					tileLayerComponent.urlTemplate,
					tileLayerComponent
				);

				if (tileLayerComponent.isDefault) {
					defaultTileLayer = tileLayer;
				}

				if (tileLayerComponent.includeInBaseLayers) {
					baseLayers[tileLayerComponent.name] = tileLayer;
				}
			}
		);

		this._map = L.map(
			'map',
			{
				// Control Options
				zoomControl: true,

				// Map State Options
      	center: [currentPosition.latitude, currentPosition.longitude],
      	zoom: 4,
				maxBounds: [[-150, -240], [120, 210]],

				// Panning Inertia Options
				worldCopyJump: true, // Keeps markers and other data when scrolling outside of world bounds.

				maxBoundsViscosity: 1.0,

				layers: [defaultTileLayer],
  	  }
		);

		let overlays = {};

		this.addComponentsAsLayers(this.geoJSONlayers, overlays);

		this.addComponentsAsLayers(this.markers, overlays);
		this.addComponentsAsLayers(this.circleMarkers, overlays);
		this.addComponentsAsLayers(this.circles, overlays);
		
		this.addComponentsAsLayers(this.arcs, overlays);

		L.control.layers(
			baseLayers,
			overlays,
			{
				collapsed: true
			}
		).addTo(this._map);

		
	}

  constructor(
		private _locationService: LocationService,
		// private _base: BaseService,
	) { }

  ngOnInit(): void {
  }

	ngAfterViewInit(): void {
		this.initializeMap();
		
		

		setTimeout(() => {
			this._map.invalidateSize(true);
		}, 100);
	}

	ngAfterContentInit(): void {
	
	}
}

//? Left this for refrence on how to get elements from dom with leaflet and create a custom control.

	// public showBubblesSwitchValue: boolean = true;

	// public onShowBubblesSwitchValueChanged(event: any): void {
	// 	if (this.showBubblesSwitchValue) {
	// 		// this._map.bubbles(this._mapBubblesData);
	// 	} else {
	// 		// this._map.bubbles([]);
	// 	}
	// }


		// L.Control.BubblesSwitch = L.Control.extend(
		// 	{
		// 		options: {
		// 			position: 'topright'
		// 		},

		// 		onAdd: function (map) {
		// 			let container = L.DomUtil.get("bubbles-switch");

		// 			return container;
		// 		}
		// 	}
		// );//.addTo(this._map);

	

		